import { memo } from 'react';
import { CallCardCitationsGrid } from '@/components/callcard/CallCardCitationsGrid';

interface CallCardCitationsTabProps {
  callCardId: number;
  isReadOnly: boolean;
}

export const CallCardCitationsTab = memo(function CallCardCitationsTab({
  callCardId,
  isReadOnly,
}: CallCardCitationsTabProps) {
  return (
    <div className="tab-content-panel">
      <CallCardCitationsGrid
        callCardId={callCardId}
        isReadOnly={isReadOnly}
      />
    </div>
  );
});
